import { createContext, useEffect, useReducer } from "react"

export const DashboardContext = createContext();

const DashboardProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        (state, action) => {
            return {
                ...state,
                [action.key]: action.value
            }
        },
        {
            cars: null,
            selectedCar: 0,
            selectedCarHistory: null,
            selectedDetail: null
        }
    )

    /* useEffect(() => {
        console.log(state)
    }, [state]) */

    return (
        <DashboardContext.Provider
            value={{
                state,
                dispatch
            }}
        >
            {
                children
            }
        </DashboardContext.Provider>
    )
}

export default DashboardProvider;